import { Box, Typography } from '@mui/material'
import { IconInfoCircleFilled } from '@tabler/icons-react'

export const UpdateDocWarning: React.FC = () => {

  return (
    <Box sx={{
      gap: 3,
      padding: 3,
      display: 'flex',
      borderRadius: '12px',
      alignItems: 'center',
      flexDirection: 'row',
      border: '1px solid #EF4444'
    }}>
      <Box sx={{
        width: '40px',
      }}>
        <IconInfoCircleFilled size={40} color='#EF4444' />
      </Box>
      <Typography variant='body1'>
        ATENÇÃO: Anexe a frente e o verso do RG/CNH utilizando os dois campos, mesmo que a frente e o verso estejam na mesma imagem. <br /> <span style={{ fontWeight: 600 }}>Nenhum campo pode ficar vazio.</span>
      </Typography>
    </Box>
  )
}
